<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Dealers
                  </v-toolbar-title>
                </div>
                <!-- <div class="ml-auto">
                  <v-btn color="primary" @click="addDealer()">
                    <v-icon class="mr-2">mdi-plus</v-icon> Add
                  </v-btn>
                </div> -->
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <!-- <template
        v-for="header in headers.filter((header) =>
          header.hasOwnProperty('formatter')
        )"
        v-slot:[`item.${header.value}`]="{ value }"
      >
        {{ header.formatter(value) }}
      </template> -->

            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.isPaid`]="{ item }">
              {{ item.isPaid ? "Yes" : "No" }}
            </template>

            <template v-slot:[`item.fullname`]="{ item }">
              <a href="#" @click.prevent="showDetails(item)">{{
                `${item.firstName} ${item.middleName} ${item.lastName}`
              }}</a>
            </template>
            <!-- <template v-slot:[item.fullname]="{ item }">{{ item.first_name }} {{ item.last_name }}</template> -->

            <template v-slot:[`item.summary.activationMonthToDate`]="{ item }">
              {{ item.summary.activationMonthToDate.toLocaleString() }}
            </template>

            <template v-slot:[`item.summary.revenueMonthToDate`]="{ item }">
              {{ item.summary.revenueMonthToDate.toLocaleString() }}
            </template>

            <template v-slot:[`item.summary.totalActivation`]="{ item }">
              {{ item.summary.totalActivation.toLocaleString() }}
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn x-small color="pink" dark @click="editDrawDetail(item)">
                Edit</v-btn
              >
            </template>

            <!-- <template slot="footer">
              <v-btn style="position: absolute; left: 10px; bottom: 10px;">
                test
              </v-btn>
            </template> -->

            <!-- <template v-slot:[`item.fullname`]="{ item }">
              <a href="#" >{{ item.fullname }}</a>
            </template> -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <!-- <AddDealerDialog
      :dialog="addDealerDialog.dialog"
      @close="addDealerDialog.dialog = !addDealerDialog.dialog"
      @response="addSalesAgentResponse"
    ></AddDealerDialog> -->
    <DealerViewSales
      :data="dealerViewSales.data"
      :dialog="dealerViewSales.dialog"
      @close="dealerViewSales.dialog = !dealerViewSales.dialog"
    ></DealerViewSales>
  </v-container>
</template>

<script>
// import moment from "moment";
import DealerViewSales from "../dialogs/acquisition/DealerViewSales.vue";
// import AddDealerDialog from "../dialogs/acquisition/AddDealerDialog.vue";

export default {
  name: "Dealer",
  components: {
    // AddSalesAgentDialog,
    // AddDealerDialog,
    DealerViewSales,
  },
  data() {
    return {
      addDealerDialog: {
        dialog: false,
      },

      dealerViewSales: {
        dialog: false,
        data: {},
      },

      search: "",
      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Name",
            align: "start",
            value: "fullname",
          },

          {
            text: "Today's Activation",
            align: "center",
            value: "summary.todayActivation",
          },
          {
            text: "Activation-month-date",
            align: "center",
            value: "summary.activationMonthToDate",
          },
          {
            text: "Revenue-month-date",
            align: "center",
            value: "summary.revenueMonthToDate",
          },

          {
            text: "Total Activation",
            align: "center",
            value: "summary.totalActivation",
          },
          // {
          //   text: "Status",
          //   align: "start",
          //   value: "statue",
          // },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$api
        .get("/acquisition/report?report=dealer-dashboard-home")
        .then((response) => {
          console.log(response);
          const newArr = response.data.data.retailers;
          this.table.data = newArr;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    addSalesAgentResponse(res) {
      if (res) {
        this.getList();
        this.addSaleAgent.dialog = false;
      }
    },

    addDealer() {
      this.addDealerDialog.dialog = true;
    },

    showDetails(data) {
      // this.retailerViewSales.reportName = reportName;
      this.dealerViewSales.data = data;
      this.dealerViewSales.dialog = true;
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>
